// Web implementation of react-native-image-picker via a hidden <input type=file>.
// Returns the RN-shaped result. The picked `uri` is an object URL (blob:) which
// the upload path (api/writes.updateUserProfile) fetches into a Blob for multipart.
function pickFile(capture) {
  return new Promise((resolve) => {
    let settled = false
    const done = (v) => {
      if (settled) return
      settled = true
      resolve(v)
    }
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/*'
    if (capture) input.capture = 'environment'
    input.style.display = 'none'
    input.onchange = () => {
      const file = input.files && input.files[0]
      if (!file) return done({ didCancel: true, assets: [] })
      done({
        didCancel: false,
        assets: [
          {
            uri: URL.createObjectURL(file),
            fileName: file.name,
            type: file.type || 'image/jpeg',
            fileSize: file.size,
          },
        ],
      })
      input.remove()
    }
    // No reliable "cancel" event for file inputs; when the window regains focus
    // without a selection, treat it as cancelled.
    window.addEventListener(
      'focus',
      () => setTimeout(() => done({ didCancel: true, assets: [] }), 400),
      { once: true },
    )
    document.body.appendChild(input)
    input.click()
  })
}

export const launchImageLibrary = () => pickFile(false)
export const launchCamera = () => pickFile(true)
export default { launchImageLibrary, launchCamera }
